export const CONFIG_REQUEST = "CONFIG_REQUEST";
export const CONTENTLOADING_TRUE = 'CONTENTLOADING_TRUE';
export const CONTENTLOADING_FALSE = 'CONTENTLOADING_FALSE';